// Hosted checkout must remain usable when Stripe.js is blocked or delayed.
export function redirectToStripeCheckout(url: unknown): void {
  if (typeof url !== "string" || new URL(url).protocol !== "https:") {
    throw new Error("Stripe returned no valid hosted checkout URL");
  }
  window.location.assign(url);
}
